import { useQuery } from '@tanstack/react-query';
import { engagementApi } from '@features/engagement/api/engagement.api';

export const engagementKeys = {
  all: ['engagement'] as const,
  report: () => [...engagementKeys.all, 'report'] as const,
};

export function useEngagement() {
  return useQuery({
    queryKey: engagementKeys.report(),
    queryFn: engagementApi.report,
    // The report aggregates every budget, account and line in the project, so it
    // takes a few seconds to build. Filtering never refetches it.
    staleTime: 5 * 60_000,
  });
}
